import { render, staticRenderFns } from "./BottomLinks.vue?vue&type=template&id=679f5ad8&scoped=true&comments=true&"
import script from "./BottomLinks.vue?vue&type=script&lang=js&"
export * from "./BottomLinks.vue?vue&type=script&lang=js&"
import style0 from "./BottomLinks.vue?vue&type=style&index=0&id=679f5ad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679f5ad8",
  null
  
)

export default component.exports